module.exports = __webpack_public_path__ + "static/media/arraial-ajuda-ba.5eba6ea8.jpg";